import AgentServicesTable from './AgentServicesTable';

export default AgentServicesTable;
